var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllAttending(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 409",
    fill: "#2a848e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68",
    d: "M.001 13.08c0-.42.479-.762 1.069-.762h17.861c.591 0 1.069.342 1.069.762s-.479.76-1.069.76H1.066c-.586 0-1.065-.343-1.065-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 69",
    d: "M.001 19.241c0-.42.239-.762.535-.762h8.93c.3 0 .535.342.535.762s-.239.76-.535.76H.536c-.296 0-.535-.34-.535-.76z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 70",
    d: "M.001 6.924c0-.42.479-.76 1.069-.76h17.861c.591 0 1.069.34 1.069.76s-.479.76-1.069.76H1.066C.48 7.68.001 7.34.001 6.924z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M.001.761c0-.42.479-.76 1.069-.76h17.861c.591 0 1.069.34 1.069.76s-.479.762-1.069.762H1.066C.48 1.523.001 1.181.001.761z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 581",
    d: "M19.771 16.185a.652.652 0 00-.965.06l-4.554 5.488-2.1-2.1a.653.653 0 00-.832-.079.768.768 0 00-.213 1.016l2.287 3.872a1.19 1.19 0 00.32.353 1.075 1.075 0 001.555-.324l4.615-7.33a.77.77 0 00-.113-.956"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllAttending);
export default ForwardRef;